import { Component, OnInit,Input,Output,EventEmitter,AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-print-receipt',
  templateUrl: './print-receipt.component.html',
  styleUrls: ['./print-receipt.component.less']
})
export class PrintReceiptComponent implements OnInit,AfterViewInit {

  @Input('receiptData') data: any;
  @Output() outToParent = new EventEmitter<string>()
  
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.outToParent.emit("success")
  }

}
